export enum ProcessTypeCode {
  UPDATE_PERSONAL_DETAILS = 1,
  JOIN_PROVIDENT_FUND = 2,
  JOIN_EDUCATION_FUND = 3,
  JOIN_PENSION_FUND = 4,
  JOIN_CHILD_SAVING_FUND = 5,
  MONEY_WITHDRAWAL = 6,
  CHANGE_INVESTMENT_PATHS = 8,
  MONEY_WITHDRAWAL_SMALL_AMOUNT_PROVIDENT_FUND = 7,
  LOAN_PROCESS = 11,
  UPDATE_REPORTS_BY_MAIL_OPTION = 12,
  MONEY_WITHDRAWAL_EDUCATION_FUND = 13,
  MONEY_WITHDRAWAL_PROVIDENT_FUND = 14,
  MONEY_WITHDRAWAL_SELF_EMPLOYED_PROVIDENT_FUND = 15,
  LOAN_RECYCLE = 16,
  MONEY_WITHDRAWAL_INVESTMENT_PROVIDENT_FUND = 17,
  UPDATING_MAILING_TYPE_FOR_NOTICES_AND_UPDATES = 18,
  DEPOSIT_INVESTMENT_PROVIDENT_FUND = 19,
  REPAYMENT_LOAN = 20,
  APPOINTMENT_BENEFICIARIES = 9
}


export enum FundType {
  ANY = 0,
  PENSION_FUND = 1,
  PROVIDENT_FUND = 2,
  EDUCATION_FUND = 3,
  CHILD_SAVING_FUND = 4,
  INVESTMENT_PROVIDENT_FUND = 5,
  PERSONALLY_FOR_COMPENSATION = 9
}

export enum MemberType {
  EMPLOYEE = 1,
  SELF_EMPLOYED = 2,
  SMALL_AMOUNT = 3
}


